<template>
  <div>
    <div class="detection">
      <div class="detection_left">
        <h3 class="title">
          <span>
            <i
              :class="{
                'icon-mobile-service': productName === 'Mobile Malware Detection',
                'icon-url-service': productName === 'URL Filtering',
                'icon-app-service': productName === 'App Insights',
                'icon-wifi-service': productName === 'WiFi Security'
              }"
            ></i>
          </span>
          <p>{{ lang === 'en' ? productName : formatNames(productName) || productName }}</p>
          <div ref="time">
            <div class="timeCount" @click="timeStatus = !timeStatus" v-if="active === 'Daily'">
              {{ $t('dashboard.day') }} <i class="el-icon-arrow-down"></i>
            </div>
            <div class="timeCount" @click="timeStatus = !timeStatus" v-if="active === 'Weekly'">
              {{ $t('dashboard.week') }} <i class="el-icon-arrow-down"></i>
            </div>
            <div class="timeCount" @click="timeStatus = !timeStatus" v-if="active === 'Monthly'">
              {{ $t('dashboard.month') }} <i class="el-icon-arrow-down"></i>
            </div>
            <el-collapse-transition>
              <ul class="timeType" v-show="timeStatus">
                <li @click="changeTime('Daily')" :class="[active == 'Daily' ? 'checked' : '']">
                  {{ $t('dashboard.day') }}
                </li>
                <li @click="changeTime('Weekly')" :class="[active == 'Weekly' ? 'checked' : '']">
                  {{ $t('dashboard.week') }}
                </li>
                <li @click="changeTime('Monthly')" :class="[active == 'Monthly' ? 'checked' : '']">
                  {{ $t('dashboard.month') }}
                </li>
              </ul>
            </el-collapse-transition>
          </div>
        </h3>
        <div class="descname">
          <div class="chare_tab">
            <i class="icon-echart"></i>
            <span class="chart" v-if="active == 'Daily'">{{ $t('dashboard.daily') }}</span>
            <span class="chart" v-if="active == 'Weekly'">{{ $t('dashboard.weekly') }}</span>
            <span class="chart" v-if="active == 'Monthly'">{{ $t('dashboard.monthly') }}</span>
          </div>
          <div class="s_square">
            <span
              class="square"
              :class="{
                api_square: productName === 'Mobile Malware Detection',
                url_square: productName === 'URL Filtering',
                app_square: productName === 'App Insights'
              }"
            ></span>
            {{ $t('dashboard.apiCalls') }}
            <span class="color_red square"></span>
            {{ $t('dashboard.Malware') }}
          </div>
        </div>
        <!-- dev.. -->
        <div style="height:280px;position: relative">
          <div
            id="myChart"
            style="width:95%;height:300px;overflow-x: auto;overflow-y:hidden;color: rgba(0,0,0,0.3);"
          ></div>
          <div v-if="noData" class="noData">
            <img src="../../assets/img/noData.png" alt="" />
            <p>{{ $t('dashboard.noData') }}</p>
          </div>
        </div>
      </div>
      <div class="detection_right">
        <h4 class="right_title">
          <div class="rtitle_left">
            <i class="icon-malwarelist"></i>
            <span v-if="productName === 'Mobile Malware Detection'">{{
              $t('dashboard.malwareList')
            }}</span>
            <span v-if="productName === 'URL Filtering'">{{ $t('dashboard.urlList') }}</span>
            <span v-if="productName === 'App Insights'">{{ $t('dashboard.appList') }}</span>
          </div>
          <div class="rtitle_right">
            <i class="el-icon-mobile-phone"></i>
            <i class="icon-pe-malware"></i>
          </div>
        </h4>
        <ul class="list_ul" v-if="productName === 'Mobile Malware Detection'">
          <li class="list_li" v-for="(item, index) in malwareList.mobile" :key="index">
            <div v-if="index < 9">
              <div class="li_left">
                <div class="li_title">{{ item.name }}</div>
                <div class="li_date">{{ item.date }}</div>
              </div>
              <a class="li_right" href="item.link" target="_blank">
                <i class="el-icon-download"></i>
              </a>
            </div>
          </li>
          <li v-if="!malwareList.mobile" class="noMalwareList">
            <img src="../../assets/img/no_search.png" alt="" />
            <p>{{ $t('dashboard.noData') }}</p>
          </li>
        </ul>
        <ul class="list_ul" v-if="productName === 'URL Filtering'">
          <li class="list_li" v-for="(item, index) in malwareList.url" :key="index">
            <div v-if="index < 9">
              <div class="li_left">
                <div class="li_title">{{ item.name }}</div>
                <div class="li_date">{{ item.date }}</div>
              </div>
              <a class="li_right" href="item.link" target="_blank">
                <i class="el-icon-download"></i>
              </a>
            </div>
          </li>
          <li v-if="!malwareList.url" class="noMalwareList">
            <img src="../../assets/img/no_search.png" alt="" />
            <p>{{ $t('dashboard.noData') }}</p>
          </li>
        </ul>
        <ul class="list_ul" v-if="productName === 'App Insights'">
          <li class="noMalwareList">
            <img src="../../assets/img/no_search.png" alt="" />
            <p>{{ $t('dashboard.noData') }}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import { Message } from 'element-ui'
  import { common } from '@/views/public/common'
  export default {
    name: 'Detection',
    props: {
      productName: {
        type: String,
        required: true
      },
      apiList: {
        type: Object,
        require: true
      }
    },
    data() {
      return {
        active: 'Monthly',
        value1: 0,
        malwareList: {},
        checked: false,
        xList: [],
        totalList: [],
        maliciousList: [],
        url_history: [],
        services: [],
        urlxList: [],
        urltotalList: [],
        urlmaliciousList: [],
        appxList: [],
        apptotalList: [],
        appmaliciousList: [],
        malware_history: [],
        url_histoty: [],
        app_histoty: [],
        noData: false,
        timeType: this.$t('dashboard.day'),
        timeStatus: false
      }
    },
    watch: {
      productName: function(newVal, oldVal) {
        if (newVal == 'Mobile Malware Detection') {
          this.getMaliciousList()
        }
        if (newVal == 'URL Filtering') {
          this.getUrlMaliciousList()
        }
        if (newVal == 'App Insights') {
          this.getAppMaliciousList()
        }
      }
    },
    computed: {
      lang() {
        return this.$store.state.lang
      }
    },
    methods: {
      // object -> return 2d array in descending order
      sortObject(obj) {
        return Object.entries(obj).sort((a, z) => {
          if (a[0] === z[0]) return 0;
          else return (a[0] > z[0]) ? -1 : 1;
        })
      },
      changeTime(str) {
        // if the user clicks the active duration
        if (str === this.active) return
        // switch the current duration
        this.active = str
        this.timeStatus = false

        // initialize
        this.xList = []
        this.totalList = []
        this.maliciousList = []

        // create an ISO string of a week ago for comparison
        const date = new Date()
        let day = date.getDate()
        const weekAgo = new Date(date.setDate(day - 7)).toISOString().substring(0, 10) // yyyy-mm-dd

        for (let [date, { malware_query_count, total_count }] of this.sortObject(this.apiList)) {
          if (this.active === 'Daily') {
            this.xList.push(date)
            this.totalList.push(total_count)
            this.maliciousList.push(malware_query_count)
            break
          } else if (this.active === 'Weekly' && date < weekAgo) {
            break
          } else {
            this.xList.push(date)
            this.totalList.push(total_count)
            this.maliciousList.push(malware_query_count)
          }
        }

        this.drawLine()
      },
      drawLine() {
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChart'))
        // 绘制图表
        var option = {
          title: { text: '' },
          tooltip: {},
          grid: {
            x: 45,
            y: 10,
            x2: 20,
            y2: 50,
            borderWidth: 0
          },
          xAxis: {
            type: 'category',
            data: this.xList,
            axisLine: {
              show: false,
              lineStyle: {
                color: 'rgba(0,0,0,0.1)'
              }
            },
            axisLabel: {
              //---坐标轴 标签
              show: true, //---是否显示
              color: 'rgba(0,0,0,0.4)'
            }
          },
          yAxis: {
            type: 'value',
            scale: true,
            // splitNumber: 7,
            axisLine: {
              show: false,
              lineStyle: {
                color: 'rgba(0,0,0,0.4)'
              }
            },
            axisTick: {
              //---坐标轴 刻度
              show: false //---是否显示
            },
            splitLine: {
              //---grid 区域中的分隔线
              show: true, //---是否显示，'category'类目轴不显示，此时我的y轴为类目轴，splitLine属性是有意义的
              lineStyle: {
                color: '#eef1f6',
                width: 1,
                type: 'solid' //---类型
              }
            },
            axisLabel: {
              margin: 2,
              formatter: function(value, index) {
                if (value >= 1000) {
                  value = value / 1000 + 'k'
                }
                return value
              }
            }
          },
          series: [
            {
              name: 'API Calls',
              type: 'bar',
              data: this.totalList,
              barGap: '0',
              itemStyle: {
                normal: {
                  color: '#ffb900'
                }
              }
            },
            {
              name: 'Malware',
              type: 'bar',
              barCategoryGap: '30%',
              data: this.maliciousList,
              axisLabel: { interval: 0 },
              itemStyle: {
                normal: {
                  color: '#f56a40'
                }
              }
            }
          ]
        }
        myChart.setOption(option)
        window.onresize = myChart.resize
      },
      drawLine2() {
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChart'))
        // 绘制图表
        var option = {
          title: { text: '' },
          tooltip: {},
          grid: {
            x: 35,
            y: 10,
            x2: 20,
            y2: 50,
            borderWidth: 0
          },
          xAxis: {
            type: 'category',
            data: this.urlxList,
            axisLine: {
              show: false,
              lineStyle: {
                color: 'rgba(0,0,0,0.1)'
              }
            },
            axisLabel: {
              //---坐标轴 标签
              show: true, //---是否显示
              color: 'rgba(0,0,0,0.4)'
            }
          },
          yAxis: {
            type: 'value',
            scale: true,
            // splitNumber: 7,
            axisLine: {
              show: false,
              lineStyle: {
                color: 'rgba(0,0,0,0.4)'
              }
            },
            axisTick: {
              //---坐标轴 刻度
              show: false //---是否显示
            },
            splitLine: {
              //---grid 区域中的分隔线
              show: true, //---是否显示，'category'类目轴不显示，此时我的y轴为类目轴，splitLine属性是有意义的
              lineStyle: {
                color: '#eef1f6',
                width: 1,
                type: 'solid' //---类型
              }
            },
            axisLabel: {
              margin: 2,
              formatter: function(value, index) {
                if (value >= 1000) {
                  value = value / 1000 + 'k'
                }
                return value
              }
            }
          },
          series: [
            {
              name: 'API Calls',
              type: 'bar',
              data: this.urltotalList,
              barGap: '0',
              itemStyle: {
                normal: {
                  color: '#39C6FA'
                }
              }
            },
            {
              name: 'Maware',
              type: 'bar',
              barCategoryGap: '30%',
              data: this.urlmaliciousList,
              axisLabel: { interval: 0 },
              itemStyle: {
                normal: {
                  color: '#f56a40'
                }
              }
            }
          ]
        }
        myChart.setOption(option)
        window.onresize = myChart.resize
      },
      drawLine3() {
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChart'))
        // 绘制图表
        var option = {
          title: { text: '' },
          tooltip: {},
          grid: {
            x: 35,
            y: 10,
            x2: 20,
            y2: 50,
            borderWidth: 0
          },
          xAxis: {
            type: 'category',
            data: this.appxList,
            axisLine: {
              show: false,
              lineStyle: {
                color: 'rgba(0,0,0,0.1)'
              }
            },
            axisLabel: {
              //---坐标轴 标签
              show: true, //---是否显示
              color: 'rgba(0,0,0,0.4)'
            }
          },
          yAxis: {
            type: 'value',
            scale: true,
            // splitNumber: 7,
            axisLine: {
              show: false,
              lineStyle: {
                color: 'rgba(0,0,0,0.4)'
              }
            },
            axisTick: {
              //---坐标轴 刻度
              show: false //---是否显示
            },
            splitLine: {
              //---grid 区域中的分隔线
              show: true, //---是否显示，'category'类目轴不显示，此时我的y轴为类目轴，splitLine属性是有意义的
              lineStyle: {
                color: '#eef1f6',
                width: 1,
                type: 'solid' //---类型
              }
            },
            axisLabel: {
              margin: 2,
              formatter: function(value, index) {
                if (value >= 1000) {
                  value = value / 1000 + 'k'
                }
                return value
              }
            }
          },
          series: [
            {
              name: 'API Calls',
              type: 'bar',
              data: this.apptotalList,
              barGap: '0',
              itemStyle: {
                normal: {
                  color: '#3CDCD2'
                }
              }
            },
            {
              name: 'Maware',
              type: 'bar',
              barCategoryGap: '30%',
              data: this.appmaliciousList,
              axisLabel: { interval: 0 },
              itemStyle: {
                normal: {
                  color: '#f56a40'
                }
              }
            }
          ]
        }
        myChart.setOption(option)
        window.onresize = myChart.resize
      },
      getMaliciousList() {
        this.xList = []
        this.totalList = []
        this.maliciousList = []

        for (let [date, { malware_query_count, total_count }] of this.sortObject(this.apiList)) {
          this.xList.push(date)
          this.totalList.push(total_count)
          this.maliciousList.push(malware_query_count)
        }

        this.drawLine()
      },
      getUrlMaliciousList() {
        this.urlxList = []
        this.urltotalList = []
        this.urlmaliciousList = []
        axios
          .get('/api/user')
          .then(res => {
            this.malwareList = res.data.maliciousList || {}
            this.services = res.data.services
            this.services.forEach(item => {
              if (item.name == 'URL Filtering') {
                this.url_history = item.history
              }
            })
            if (this.url_history.length === 0) {
              this.noData = true
            } else {
              this.noData = false
            }
            this.url_history.forEach(item => {
              this.urlxList.push(item.date)
              this.urltotalList.push(item.total)
              this.urlmaliciousList.push(item.malicious)
            })
            this.drawLine2()
          })
          .catch(err => {
            Message({
              type: 'error',
              message: err.response.data.statusCode + ' ' + err.response.data.message,
              showClose: true
            })
          })
      },
      getAppMaliciousList() {
        this.appxList = []
        this.apptotalList = []
        this.appmaliciousList = []
        axios
          .get('/api/user')
          .then(res => {
            this.malwareList = res.data.maliciousList || {}
            this.services = res.data.services
            this.services.forEach(item => {
              if (item.name == 'App Insights') {
                this.app_history = item.history
              }
            })
            if (this.app_history.length === 0) {
              this.noData = true
            } else {
              this.noData = false
            }
            this.app_history.forEach(item => {
              this.appxList.push(item.date)
              this.apptotalList.push(item.total)
              this.appmaliciousList.push(item.malicious)
            })
            this.drawLine3()
          })
          .catch(err => {
            Message({
              type: 'error',
              message: err.response.data.statusCode + ' ' + err.response.data.message,
              showClose: true
            })
          })
      },
      formatNames: common.formatNames
    },
    mounted() {
      if (this.productName === 'Mobile Malware Detection') {
        this.getMaliciousList()
      } else if (this.productName === 'URL Filtering') {
        this.getUrlMaliciousList()
      } else if (this.productName === 'App Insights') {
        this.getAppMaliciousList()
      } else {
        this.getMaliciousList()
      }

      let _this = this
      document.addEventListener('click', e => {
        if (!!_this.$refs.time && !!_this.$refs.time.contains(e.target)) return
        _this.timeStatus = false
      })
    }
  }
</script>

<style lang="scss" scoped>
  .detection {
    height: 430px;
    background: $white;
    margin: 11px 0 43px;
    @include border-radius(6px);
    border: $border;
    @include box-shadow;
    @include flex-space-between;
    .detection_left {
      flex: 1;
      padding-left: 23px;
      .title {
        height: 40px;
        @include flex-align-center;
        position: relative;
        font-size: 20px;
        font-family: NexaBold;
        margin: 19px 0 11px;
        & > span {
          width: 40px;
          height: 40px;
          margin-right: 12px;
          font-size: 40px;
        }
        .timeCount {
          position: absolute;
          right: 33px;
          font-size: 14px;
          font-family: NexaBold;
          cursor: pointer;
          ::v-deep .el-icon-arrow-down {
            color: #f56a3e;
          }
        }
        .timeType {
          width: 87px;
          height: 96px;
          background: $white;
          @include box-shadow;
          @include border-radius(4px);
          padding-left: 16px;
          box-sizing: border-box;
          z-index: 200;
          @include absolute-right-top(12px, 45px);
          & > li {
            font-family: NexaLight;
            font-size: 14px;
            color: rgba(31, 37, 62, 0.4);
            line-height: 32px;
            font-weight: 400;
            &:hover {
              color: rgba(245, 106, 62, 0.7);
              cursor: pointer;
            }
          }
        }
      }
      .checked {
        color: rgba(245, 106, 62, 0.7) !important;
        cursor: default !important;
      }
      .descname {
        height: 18px;
        font-size: 12px;
        font-family: NexaLight;
        color: rgba(31, 37, 62, 0.7);
        @include flex-align-center;
        margin-bottom: 45px;
        .echart_table {
          height: 18px;
          display: flex;
          align-items: center;
        }
        .icon-echart {
          font-size: 14px;
          margin-left: 52px;
          margin-right: 5px;
        }
        .chart {
          font-size: 14px;
          font-family: NexaBold;
          font-weight: 900;
          margin-right: 62px;
        }
        .s_square {
          height: 17px;
          @include flex-align-center;
        }
        .square {
          display: inline-block;
          width: 17px;
          height: 17px;
          margin-right: 10px;
        }
        .api_square {
          background: #ffb900;
        }
        .url_square {
          background: #39c6fa;
        }
        .app_square {
          background: #3cdcd2;
        }
        .color_red {
          background: $primary-color;
          margin-left: 47px;
        }
      }
      .noData {
        @include absolute-left-top(40%, 50px);
        color: $primary-color;
        text-align: center;
        font-size: 16px;
        line-height: 23px;
        & > img {
          width: 87px;
          height: 88px;
          margin-bottom: 11px;
        }
      }
    }
    .detection_right {
      width: 221px;
      border-left: $border;
      .right_title {
        height: 40px;
        font-size: 16px;
        font-family: NexaBold;
        @include flex-space-center;
        padding: 0 11px;
        box-sizing: border-box;
        margin: 19px 0 11px;
        .rtitle_left {
          .icon-malwarelist {
            width: 14px;
            height: 14px;
            margin-right: 5px;
          }
        }
        .el-icon-mobile-phone {
          color: $primary-color;
        }
        .icon-pe-malware {
          color: #ccd4ee;
        }
      }
      .list_ul {
        .list_li {
          & > div {
            height: 40px;
            @include flex-space-center;
            box-sizing: border-box;
            padding: 0 11px;
            &:active,
            &:hover,
            &:visited {
              box-shadow: 0px 4px 10px 0px rgba(175, 185, 205, 0.4);
              .li_right ::v-deep .el-icon-download {
                color: $primary-color;
              }
            }
            .li_left {
              .li_title {
                height: 15px;
                font-size: 12px;
                color: #545454;
                margin-bottom: 2px;
                line-height: 15px;
                font-family: Lato-Bold;
                font-weight: bold;
              }
              .li_date {
                height: 12px;
                line-height: 10px;
                font-size: 10px;
                font-family: Lato-Regular;
                font-weight: 400;
                color: rgba(31, 37, 62, 0.3);
              }
            }
            .li_right {
              ::v-deep .el-icon-download {
                color: #ccd4ee;
                font-weight: 900;
                font-size: 14px;
                text-align: right;
              }
            }
          }
        }
        .noMalwareList {
          margin: 112px auto 0;
          color: $primary-color;
          font-size: 16px;
          line-height: 23px;
          text-align: center;
          & > img {
            width: 87px;
            height: 88px;
            margin-bottom: 11px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 1231px) {
    .detection {
      height: auto;
      display: block;
      border: 0;
      background: transparent;
      box-shadow: none;
      .detection_left {
        width: 100%;
        height: 430px;
        margin-bottom: 30px;
        border: $border;
        @include border-radius(6px);
        background: $white;
        box-sizing: border-box;
        @include box-shadow;
        .descname {
          margin-bottom: 30px;
        }
      }
      .detection_right {
        width: 100%;
        border: $border;
        @include border-radius(6px);
        height: auto;
        background: $white;
        @include box-shadow;
        padding-bottom: 20px;
        .right_title {
          margin: 19px 12px 11px;
          .rtitle_left {
            .icon-malwarelist {
              font-size: 14px;
            }
          }
        }
        .list_ul .list_li > div {
          padding: 0 23px;
        }
        .list_ul .noMalwareList {
          margin: 30px auto 50px;
        }
      }
    }
  }

  @media screen and (max-width: 450px) {
    .detection {
      .detection_left {
        height: 430px;
        padding-left: 23px;
        box-shadow: none;
        .title {
          display: block;
          height: 19px;
          font-size: 16px;
          margin: 24px 0 20px;
          text-align: center;
          & > span {
            display: none;
          }
          .timeCount {
            @include absolute-right-top(23px, 38px);
            font-size: 12px;
          }
          .timeType {
            text-align: left;
            @include absolute-right-top(12px, 65px);
          }
        }
        .descname {
          display: block;
          height: 40px;
          box-sizing: border-box;
          .icon-echart {
            font-size: 14px;
            margin-right: 5px;
            margin-left: 0;
          }
          .chart {
            font-size: 14px;
            font-family: NexaBold;
            font-weight: 900;
            margin-right: 16px;
          }
          .s_square {
            display: block;
            margin-top: 8px;
          }
          .square {
            display: inline-block;
            width: 10px;
            height: 10px;
            margin-right: 5px;
          }
          .color_red {
            margin-left: 4px;
          }
        }
        .noData {
          left: 33%;
        }
      }
      .detection_right {
        box-shadow: none;
        .list_ul .list_li > div {
          height: 60px;
          .li_left {
            .li_title {
              font-size: 14px;
            }
            .li_date {
              font-size: 12px;
              margin-top: 8px;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/detection.vue